import { AlertCircleIcon } from "lucide-react";
import type { Dictionary } from "../../../../dictionaries";
import { StatusOverlay } from "./status-overlay";

interface PaymentFailedViewProps {
  reason?: string;
  onRetry: () => void;
  dictionary: Dictionary;
}

export function PaymentFailedView({
  reason,
  onRetry,
  dictionary,
}: PaymentFailedViewProps) {
  const { status } = dictionary;

  return (
    <StatusOverlay
      icon={
        <div className="flex size-16 items-center justify-center rounded-full bg-destructive/10">
          <AlertCircleIcon className="size-8 text-destructive" />
        </div>
      }
      title={status.failed.title}
      description={reason || status.failed.description}
      cancelLabel={status.failed.retry}
      onCancel={onRetry}
    />
  );
}
